define.alias("shared/errors/api-authorization-error", "media/errors/api-authorization-error");